import {
  FileTextOutlined,
  PaperClipOutlined,
  PlayCircleFilled,
  SafetyCertificateOutlined,
} from '@ant-design/icons';
import { getColorByKey } from '@frontend/shared/util';
import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';

export enum ContentTypes {
  VIDEO_EMPTY = 'VIDEO_EMPTY',
  VIDEO_PROCESSING = 'VIDEO_PROCESSING',
  VIDEO_NO_PERMISSION = 'VIDEO_NO_PERMISSION',
  POST_NO_BANNER = 'POST_NO_BANNER',
}

export interface ContentPlaceholderProps {
  type: ContentTypes;
  id: string;
  className?: string;
  kind?: string;
}

export function ContentPlaceholder({
  className = '',
  id,
  type,
  kind,
}: ContentPlaceholderProps) {
  const { t } = useTranslation('common');

  const contentMap = useMemo(
    () => [
      {
        contentType: ContentTypes.VIDEO_EMPTY,
        contentImage: (
          <PaperClipOutlined
            style={{ fontSize: '35px', color: 'rgba(255, 255, 255, 0.75)' }}
          />
        ),
        customText: t('content_placeholder_video_empty'),
      },
      {
        contentType: ContentTypes.VIDEO_PROCESSING,
        contentImage: (
          <SafetyCertificateOutlined
            style={{ fontSize: '35px', color: 'rgba(255, 255, 255, 0.75)' }}
          />
        ),
        customText: t('content_placeholder_video_processing'),
      },
      {
        contentType: ContentTypes.VIDEO_NO_PERMISSION,
        contentImage: (
          <PlayCircleFilled
            style={{ fontSize: '35px', color: 'rgba(255, 255, 255, 0.75)' }}
          />
        ),
        customText: t('content_placeholder_video_no_permission'),
      },
      {
        contentType: ContentTypes.POST_NO_BANNER,
        contentImage: (
          <FileTextOutlined
            style={{ fontSize: '35px', color: 'rgba(255, 255, 255, 0.75)' }}
          />
        ),
        customText: undefined,
      },
    ],
    [t]
  );
  const getImage = (type: ContentTypes) =>
    contentMap.find((map) => map.contentType === type)?.contentImage;
  const getText = (type: ContentTypes) =>
    contentMap.find((map) => map.contentType === type)?.customText;

  return (
    <div
      className={`${className} ${kind === 'banner' && 'h-[330.75px]'} ${
        kind === 'company' && 'h-48'
      } w-full flex flex-col items-center justify-center p-10 rounded-2xl group-hover:rounded-b-none ease-in duration-300`}
      style={{ backgroundColor: getColorByKey(id) }}
    >
      {getImage(type)}
      {getText(type) && (
        <div className="text-white px-10 text-center mt-6 drop-shadow-md">
          {getText(type)}
        </div>
      )}
    </div>
  );
}

export default ContentPlaceholder;
